import { HashMap, HashSet } from '@rimbu/hashed';
import { GraphContext } from '@rimbu/graph/custom';
function createContext(options) {
    return Object.freeze(new GraphContext(true, 'ArrowGraphHashed', options?.linkMapContext ?? HashMap.defaultContext(), options?.linkConnectionsContext ?? HashSet.defaultContext()));
}
const _defaultContext = createContext();
export const ArrowGraphHashed = Object.freeze({
    ..._defaultContext,
    createContext,
    defaultContext() {
        return _defaultContext;
    },
});
//# sourceMappingURL=arrow-graph-hashed.mjs.map